module.exports = __webpack_public_path__ + "static/flight-3c-2329562085c9d964f55af03a74347972.svg";